import React from "react";

export default function WhyChooseUs() {
  const items = [
    {
      title: "Expert Team",
      desc: "Highly skilled professionals delivering top-quality work.",
      img: "/images/whychooseus/new1.jpg",
    },
    {
      title: "Quality Service",
      desc: "Premium service with strong attention to detail.",
      img: "/images/home/quantityservice.jpg",
    },
    {
      title: "Fast Delivery",
      desc: "We ensure quick and on-time project completion.",
      img: "/images/whychooseus/new22.jpg",
    },
    {
      title: "24/7 Support",
      desc: "Dedicated support anytime you need assistance.",
      img: "/images/whychooseus/new33.jpg",
    },
  ];

  return (
    <section className="py-5 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 text-center mb-2">
        <h2 className="text-3xl font-bold mb-2">Why Choose Us</h2>
        <p className="text-gray-600">
          We provide exceptional quality, reliability and customer satisfaction.
        </p>
      </div>
      <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-4 gap-8">
        {items.map((item, idx) => (
          <div key={idx} className="p-6 bg-white rounded-lg shadow text-center">
            <img
              src={item.img}
              alt={item.title}
              className="w-full h-32 object-cover rounded mb-4"
            />
            <h5 className="font-bold mb-2">{item.title}</h5>
            <p className="text-gray-700 text-sm">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
